/**
 * view operations
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


import {openPageAction, openMediaOverlayAction, closeMediaOverlayAction} from "../redux/view/actions";
import {getMediaUrl} from "./utils";


export function openPage(pageId) {
    return dispatch => {
        dispatch(openPageAction(pageId));
    }
}

export function openMediaOverlayForObject(object) {
    return dispatch => {
        const url = getMediaUrl(object);
        const description = object.title;
        dispatch(openMediaOverlayAction(url, description || url));
    }
}

export function openMediaOverlayForUrl(url, description) {
    return dispatch => {
        dispatch(openMediaOverlayAction(url, description || url));
    }
}

export function closeMediaOverlay() {
    return dispatch => {
        dispatch(closeMediaOverlayAction());
    }
}
